export default __webpack_public_path__ + "static/media/BudgetTracker.3e3e1849.PNG";